module.exports = __webpack_public_path__ + "img/sauna_laavu9.2c22de31.jpg";